// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPublicationRequestSchema {
  /** Название компании **/
  companyName: string;
  /** Вид деятельности **/
  companyType: ECompanyType;
  /** E-mail **/
  email: string;
  /** Тестовая ли заявка **/
  isTest?: boolean;
  /** Телефон **/
  phone: string;
}
export enum ECompanyType {
  /** Брокер **/
  'Broker' = 'broker',
  /** Собственник бизнес-центра **/
  'BusinessCenterOwner' = 'businessCenterOwner',
  /** Управляющая компания **/
  'ManagementCompany' = 'managementCompany',
  /** Оператор коворкинга **/
  'Operator' = 'operator',
}
